import React, { createContext, useContext } from 'react';

const LibraryOrgContext = createContext(null);

export const useLibraryOrg = () => {
  const context = useContext(LibraryOrgContext);
  if (!context) {
    throw new Error('useLibraryOrg must be used within a LibraryOrgProvider');
  }
  return context;
};

export const LibraryOrgProvider = ({ org, children }) => (
  <LibraryOrgContext.Provider value={org}>{children}</LibraryOrgContext.Provider>
);

export default LibraryOrgContext;
